import api from './api';

export const pullOrdersFromWooCommerce = async (params: {
  start_date?: string;
  end_date?: string;
  pull_tracking?: string;
} = {}) => {
  try {
    const query = new URLSearchParams();
    if (params.start_date) query.append('start_date', params.start_date);
    if (params.end_date) query.append('end_date', params.end_date);
    if (params.pull_tracking) query.append('pull_tracking', params.pull_tracking);
    const response = await api.get(`/pull-orders?${query.toString()}`);
    return response.data;
  } catch (error: any) {
    console.error('Pull orders error:', error);
    throw error;
  }
};

export const fetchOrders = async (page: number = 1, perPage: number = 0, status?: string) => {
  try {
    const params: any = { page, per_page: perPage };
    if (status) params.status = status;
    const response = await api.get('/orders', { params });
    console.log('fetchOrders API Response:', JSON.stringify(response.data, null, 2));
    return {
      data: Array.isArray(response.data) ? response.data : [response.data].filter(Boolean),
      customer_types: Array.isArray(response.data.customer_types) ? response.data.customer_types : [],
      last_updated: response.data.last_updated || '',
    };
  } catch (error: any) {
    console.error('Fetch orders error:', error);
    throw error;
  }
};

export const updateCustomerType = async (
  orderId: number,
  customerType: string,
  customerName: string
) => {
  try {
    const response = await api.post('/update-customer-type', {
      order_id: orderId,
      customer_type: customerType,
      customer_name: customerName,
    });
    return response.data;
  } catch (error: any) {
    console.error('Update customer type error:', error);
    throw error;
  }
};

export const addOrderNote = async (
  orderId: number,
  note: string,
  addedBy: string
) => {
  try {
    const response = await api.post('/add-order-note', {
      order_id: orderId,
      note,
      added_by: addedBy,
    });
    return response.data;
  } catch (error: any) {
    console.error('Add order note error:', error);
    throw error;
  }
};

export const updateOrderStatus = async (
  orderId: number,
  status: string
) => {
  try {
    const response = await api.post('/update-order-status', {
      order_id: orderId,
      status,
    });
    return response.data;
  } catch (error: any) {
    console.error('Update order status error:', error);
    throw error;
  }
};

export const syncWooCommerceOrder = async (
  orderId: number,
  updates: {
    status?: string;
    notes?: { content: string; added_by: string }[];
    tracking_numbers?: { tracking_number: string; carrier: string; date_shipped: string }[];
  }
) => {
  try {
    const response = await api.post('/sync-woocommerce-order', {
      order_id: orderId,
      updates,
    });
    return response.data;
  } catch (error: any) {
    console.error('Sync WooCommerce order error:', error);
    throw error;
  }
};